<template>
  <CockpitDialog width="500px" height="250px" :title="$t('报警内容')" @close="() => $emit('close')">
    <div class="w-full h-full overflow-x-hidden text-hex-fff text-14px">
      <div v-for="(it, index) in detailData" :key="index" class="mb-15px flex">
        <p class="leading-20px">{{ it.label }}：</p>
        <span class="leading-20px flex-1">{{ it.value }}</span>
      </div>
    </div>
  </CockpitDialog>
</template>

<script>
import CockpitDialog from '@/components/cockpit/CockpitDialog'

export default {
  data() {
    return {}
  },
  methods: {},
  created() {},
  components: { CockpitDialog },
  props: {
    detailData: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
}
</script>

<style></style>
